import {
    CLEAR_DRAW_RESULT_VN1,
    FETCH_DRAW_RESULT_VN1,
    LIST_DRAW_RESULT_VN1,
    MODIFY_DRAW_RESULT_VN1
} from "./types";

const init = {
    isLoading: false,
    filter: {}
};


export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_DRAW_RESULT_VN1:
            return {
                ...state,
                filter: payload,
                isLoading: false
            };
        case LIST_DRAW_RESULT_VN1 :
            return {
                ...state,
                isLoading: false,
                ...payload

            };
        case MODIFY_DRAW_RESULT_VN1:
            return {
                ...state,
                isLoading: true,
            };

        case CLEAR_DRAW_RESULT_VN1:
            return {
                ...init
            };

        default:
            return state;
    }
}
